import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../../components/table/tableCustom';
import { Button, useMediaQuery, useTheme } from '@mui/material';
import TableRowCommon from '../../../../components/table/TableRowCommon';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { listTypeGetRoomMeetingServiceList, roomMeetingServiceApi } from '../../../../api/booking-room-fees/booking-room-fees.api';
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom';
import { icons } from '../../../../assets/icons/icons';
import ModalCustom from '../../../../components/modal/modalCustomCms';
import StateComponents from '../../../../components/state-component/StateComponents';
import { room_meeting_service_list_type } from '../../../../api/booking-room-devices/booking-room-devices.api';
import { produce } from 'immer';
import { alertActive, alertSuccess } from '../../../../components/alert/swal';
import clsx from 'clsx';
import { debouncedApiCall } from '../../../../utils/app.utils';
import { listRoomMeetingService, room_meeting_service_data, RoomMeetingServiceApi } from '../../../../api/room-meeting-service/room_meeting_service.api';
import { BookingMeetingRoomServiceApi } from '../../../../api/booking-meeting-room-service/booking-meeting-room-service.api';
import { useTranslation } from 'react-i18next';

type Props = {
    id_room_meeting: number;
    id_meeting_room?: number;
    is_booking?: boolean;
    view?: boolean;
    is_personal?: boolean;
}

const RoomMeetingService: React.FC<Props> = ({ view, is_personal, id_room_meeting, id_meeting_room, is_booking }: Props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const dispatch = useDispatch();

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const [data, setData] = useState<any[]>([]);
    const [room_meeting_service_data, set_room_meeting_service_data] = useState<any[]>([]);
    const [search_room_meeting_service_data, set_search_room_meeting_service_data] = useState<string>("");
    const [search_data, set_search_data] = useState<any>(null);
    const [id_room_meeting_service, set_id_room_meeting_service] = useState<number | null>(null);
    const [id_meeting_room_service, set_id_meeting_room_service] = useState<number | null>(null);


    const [is_view, set_is_view] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const defaultFormState: room_meeting_service_data = {
        id_room_meeting: null,
        id_room_metting_service: null,
        qty: "",
        room_metting_service_amount: "",
        room_metting_service_amount_usd: "",
        room_metting_service_name: "",
        room_meeting_service_desc: "",
        status: 'active'
    }
    const [formState, setFormState] = useState<room_meeting_service_data>(defaultFormState);
    const [other_detail, set_other_detail] = useState<{ room_metting_service_amount: string, room_metting_service_amount_usd: string }>({
        room_metting_service_amount: "",
        room_metting_service_amount_usd: ""
    })

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const handleCloseModal = () => {
        setShowModal(false);
        setFormState(defaultFormState);
        set_search_data(null);
        set_is_view(false);
        set_search_room_meeting_service_data("");
        set_id_room_meeting_service(null);
        set_other_detail({
            room_metting_service_amount: "",
            room_metting_service_amount_usd: ""
        })
    }
    function handleChangeFormState<K extends keyof room_meeting_service_data>(
        field: K,
        value: room_meeting_service_data[K]
    ) {
        setFormState(prev =>
            produce(prev, draft => {
                draft[field] = value;
            })
        );
    }
    const handleClearSearchData = () => {
        setFormState(defaultFormState);
        set_search_data(null);
    }
    const handleSearchData = () => {
        setFormState({
            id_room_meeting: id_room_meeting,
            id_room_metting_service: search_data?.id_room_metting_service,
            qty: "",
            room_metting_service_amount: search_data?.room_metting_service_amount,
            room_meeting_service_desc: search_data?.room_meeting_service_desc,
            room_metting_service_amount_usd: search_data?.room_metting_service_amount_usd,
            room_metting_service_name: search_data?.room_metting_service_name,
            status: formState.status,
        })
        set_other_detail({
            room_metting_service_amount: search_data?.room_metting_service_amount,
            room_metting_service_amount_usd: search_data?.room_metting_service_amount_usd
        })
    }


    const headCells = [
        {
            id: "no",
            width: 50,
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("ลำดับ"),
        },
        {
            id: "service_name",
            width: 100,
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("ชื่อบริการ"),
        },
        {
            id: "qty",
            width: 150,
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("จำนวน"),
        },
        {
            id: "action",
            width: 75,
            sortable: false,
            disablePadding: false,
            align: "start",
            class: matches && data?.length == 0,
            label: "",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { room_metting_service_name, room_metting_service_amount, room_metting_service_amount_usd, id_room_metting_service, id_meeting_room_service, qty } =
            objData;

        const objRenderData = {
            key: id_room_metting_service,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no ?? "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: room_metting_service_name || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: qty ?? "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches,
                    component: (
                        <div className='w-full flex justify-center items-center'>
                            <OptionsButtonCustom
                                enableView
                                enableEdit={!view}
                                enableDelete={!view}
                                onDeleteClick={() => {
                                    if (is_booking) {
                                        id_meeting_room_service && handleDeleteMeetingRoomService(id_meeting_room_service)
                                    } else {
                                        id_room_metting_service && handleDeleteMeetingRoomService(id_room_metting_service)
                                    }
                                }}
                                onViewClick={() => {
                                    setShowModal(true);
                                    set_is_view(true)
                                    setFormState(() => ({ ...objData, qty: String(objData?.qty || "") }));
                                    set_other_detail({
                                        room_metting_service_amount: room_metting_service_amount || "",
                                        room_metting_service_amount_usd: room_metting_service_amount_usd || ""
                                    })
                                    set_id_room_meeting_service(id_room_metting_service);
                                    set_id_meeting_room_service(id_meeting_room_service);
                                }}
                                onEditClick={() => {
                                    setShowModal(true);
                                    setFormState(() => ({ ...objData, qty: String(objData?.qty || "") }));
                                    set_other_detail({
                                        room_metting_service_amount: room_metting_service_amount || "",
                                        room_metting_service_amount_usd: room_metting_service_amount_usd || ""
                                    })
                                    set_id_room_meeting_service(id_room_metting_service);
                                    set_id_meeting_room_service(id_meeting_room_service)
                                }}
                            />
                        </div>
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };

    const handleSubmit = async () => {
        const body: room_meeting_service_data = {
            ...(is_booking ? {
                id_meeting_room: id_meeting_room,
                id_room_meeting: formState.id_room_meeting
            } : {
                id_room_meeting: formState.id_room_meeting,
            }),
            id_room_metting_service: formState.id_room_metting_service,
            qty: formState.qty ? +formState.qty : 0,
            room_metting_service_amount: formState.room_metting_service_amount,
            room_meeting_service_desc: formState.room_meeting_service_desc,
            room_metting_service_name: formState.room_metting_service_name,
            room_metting_service_amount_usd: formState.room_metting_service_amount_usd,
            status: formState.status
        }
        dispatch(setLoading());
        if (is_booking) {
            if (id_meeting_room_service) {
                await BookingMeetingRoomServiceApi.updateBookingMeetingRoom(id_meeting_room_service, body).then((res) => {
                    if (res.status < 300) {
                        handleCloseModal();
                        handleGetData();
                        alertSuccess(t("อัพเดตบริการ"), t("อัพเดตบริการ เรียบร้อยแล้ว"));
                    }
                }).catch((err) => {
                    console.log(err)
                }).finally(() => {
                    dispatch(unsetLoading());
                })
            } else {
                await BookingMeetingRoomServiceApi.createBookingMeetingRoom(body).then((res) => {
                    if (res.status < 300) {
                        handleCloseModal();
                        handleGetData();
                        alertSuccess(t("เพิ่มบริการ"), t("เพิ่มบริการ เรียบร้อยแล้ว"));
                    }
                }).catch((err) => {
                    console.log(err)
                }).finally(() => {
                    dispatch(unsetLoading());
                })
            }

        } else {
            if (id_room_meeting_service) {
                await RoomMeetingServiceApi.update(id_room_meeting_service, body).then((res) => {
                    if (res.status < 300) {
                        handleCloseModal();
                        handleGetData();
                        alertSuccess(t("อัพเดตบริการ"), t("อัพเดตบริการ เรียบร้อยแล้ว"));
                    }
                }).catch((err) => {
                    console.log(err)
                }).finally(() => {
                    dispatch(unsetLoading());
                })
            } else {
                await RoomMeetingServiceApi.create(body).then((res) => {
                    if (res.status < 300) {
                        handleCloseModal();
                        handleGetData();
                        alertSuccess(t("เพิ่มบริการ"), t("เพิ่มบริการ เรียบร้อยแล้ว"));
                    }
                }).catch((err) => {
                    console.log(err)
                }).finally(() => {
                    dispatch(unsetLoading());
                })
            }
        }
    }
    const handleDeleteMeetingRoomService = (pk_id: number) => {
        alertActive(t("ลบรายการ"), t("ต้องการลบรายการนี้หรือไม่?"), undefined, undefined, async () => {
            dispatch(setLoading());
            if (is_booking) {
                await BookingMeetingRoomServiceApi.deleteServiceImMeetingRoomById(pk_id).then((res) => {
                    if (res.status < 300) {
                        handleGetData();
                        alertSuccess(t("ลบรายการ"), t("ลบรายการสำเร็จ"))
                    }
                }).catch((err) => {
                    console.log(err)
                }).finally(() => {
                    dispatch(unsetLoading());
                })
            } else {
                await RoomMeetingServiceApi.delete(pk_id).then((res) => {
                    if (res.status < 300) {
                        handleGetData();
                        alertSuccess(t("ลบรายการ"), t("ลบรายการสำเร็จ"))
                    }
                }).catch((err) => {
                    console.log(err)
                }).finally(() => {
                    dispatch(unsetLoading());
                })
            }

        })
    }

    const handleGetRoomMeetingServiceData = useCallback(async () => {
        let query: room_meeting_service_list_type = { page: 1, limit: 20 }
        if (search_room_meeting_service_data) query.keyword = search_room_meeting_service_data
        await roomMeetingServiceApi.getRoomMeetingServiceList(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_room_meeting_service_data(response)
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [search_room_meeting_service_data])

    const handleGetData = useCallback(async () => {
        let query: listRoomMeetingService = {
            page: page,
            limit: pageLimit,
            id_meeting_room: id_meeting_room
        }
        dispatch(setLoading());
        if (is_booking) {
            await BookingMeetingRoomServiceApi.listMeetingBookingService(query).then((res) => {
                if (res.status < 300) {
                    const response = res.data?.data?.items || [];
                    setData(response);
                    setTotalItems(res.data?.data?.meta?.totalItems || 0);
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading())
            })
        } else {
            await RoomMeetingServiceApi.list(query).then((res) => {
                if (res.status < 300) {
                    const response = res.data?.data?.items || [];
                    setData(response);
                    setTotalItems(res.data?.data?.meta?.totalItems || 0);
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading())
            })
        }
    }, [page, pageLimit])

    useEffect(() => {
        handleGetRoomMeetingServiceData();
    }, [handleGetRoomMeetingServiceData])
    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    return (
        <section className="w-full mt-10">
            {!view && (
                <div className='flex justify-end items-center my-4'>
                    <Button onClick={() => {
                        setShowModal(true);
                    }} color='success' startIcon={<icons.add2 />} variant='contained'>
                        {t("เพิ่ม")}
                    </Button>
                </div>
            )}
            <div className='w-full'>
                <TableCustom
                    tableMinWidth={1040}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data?.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </div>

            {showModal && (
                <ModalCustom
                    handleClose={handleCloseModal}
                    onClick={handleSubmit}
                    open
                    title={id_room_meeting_service ? t('รายละเอียดบริการ') : t('เพิ่มบริการ')}
                    subTitle={t("กรุณาเลือกรายการที่ท่านต้องการ")}
                    scrollBody
                    disabledSubmitButton={!formState.id_room_metting_service || !formState.qty}
                    maxWidth='md'
                    hintSubmitButton={is_view || view}
                    form={
                        <div className='w-full py-6'>
                            {(!is_view || !view) && !id_room_meeting_service && (
                                <div className='grid grid-cols-12 gap-4'>
                                    <span className='col-span-12 lg:col-span-8'>
                                        <StateComponents
                                            typeProps={[
                                                {
                                                    seq: 1,
                                                    gridProps: {
                                                        xs: 12
                                                    },
                                                    type: "AUTO-COMPLETE",
                                                    fieldProps: {
                                                        placeholder: t("ค้นหา"),
                                                        startAdornment: <div className='mr-2'><icons.SearchNormal /></div>,
                                                        getOptionLabel: (op) => op?.room_metting_service_name || "",
                                                        labelId: "room_metting_service",
                                                        onChange: (_, val) => set_search_data(val ?? null),
                                                        onInputChange: (_: any, val: string) => debouncedApiCall({ searchItem: val, setItem: set_search_room_meeting_service_data }),
                                                        options: room_meeting_service_data || [],
                                                        value: search_data || null
                                                    }
                                                }
                                            ]}
                                        />
                                    </span>
                                    <span className='flex gap-4 col-span-12 lg:col-span-4'>
                                        <Button onClick={handleSearchData} disabled={!search_data} fullWidth variant='contained' color='success'>{t("ค้นหา")}</Button>
                                        <Button onClick={handleClearSearchData} fullWidth startIcon={<img src={icons.close_square} alt='icons' />} variant='contained' color='error'>{t("ล้างค่า")}</Button>
                                    </span>
                                </div>
                            )}
                            <StateComponents
                                sxContainer={{ my: 2 }}
                                disabledAllField={is_view}
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            disabled: true,
                                            heading: t("ชื่อบริการ"),
                                            value: formState.room_metting_service_name,
                                        }
                                    },
                                    // TODO: ไม่มีเก็บใน master
                                    {
                                        seq: 2,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            disabled: true,
                                            heading: t("รายละเอียดบริการ"),
                                            row: 4,
                                            inputHeight: "auto",
                                            value: formState.room_meeting_service_desc,
                                            multiline: true,
                                            disablePaddingMultiline: true,
                                        }
                                    },
                                    ...(is_personal ? [] : [
                                        {
                                            seq: 3,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 6
                                            },
                                            fieldProps: {
                                                disabled: true,
                                                heading: t("ค่าบริการ (THB) / หน่วย"),
                                                value: other_detail.room_metting_service_amount,
                                            }
                                        },
                                        {
                                            seq: 4,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 6
                                            },
                                            fieldProps: {
                                                disabled: true,
                                                heading: t("ค่าบริการ  (USD) / หน่วย"),
                                                value: other_detail.room_metting_service_amount_usd,
                                            }
                                        },
                                    ] as any),

                                ]}
                            />
                            <div className='grid grid-cols-12 gap-4'>
                                <span className={clsx('col-span-12 ', {
                                    'lg:col-span-10': !is_view
                                })}>
                                    <StateComponents
                                        disabledAllField={is_view}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                type: "TEXT-MASK",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    disabled: !formState.id_room_metting_service,
                                                    mode: "full_number",
                                                    heading: t("จำนวน"),
                                                    value: String(formState.qty || ""),
                                                    placeholder: t("ระบุจำนวน"),
                                                    onChange: (e) => {
                                                        handleChangeFormState('qty', e.target.value)
                                                    }
                                                }
                                            },
                                        ]}
                                    />
                                </span>
                                {!is_view && (
                                    <span className='flex justify-center items-center col-span-12 lg:col-span-2 gap-4'>
                                        <Button disabled={Number(formState?.qty) <= 1} onClick={() => {
                                            handleChangeFormState('qty', Number(formState.qty || "") - 1)
                                        }} fullWidth variant='contained' color='error'>-</Button>
                                        <Button onClick={() => {
                                            handleChangeFormState('qty', Number(formState.qty || "") + 1)
                                        }} fullWidth variant='contained' color='success'>+</Button>
                                    </span>
                                )}
                            </div>

                        </div>
                    }
                />
            )}
        </section >
    )
}

export default RoomMeetingService